import { lazy } from "react"

export const GIFT_MODALS = {
  giftInfo: {
    component: lazy(() => import("modals/ui/gift/GiftInfo"))
  },
  giftClaim: {
    component: lazy(() => import("modals/ui/gift/GiftClaim"))
  }
} as const
